<div class="tab-pane engine__tab-pane fade show active" id="car-rental" role="tabpanel" aria-labelledby="car-rental-tab">
  <form class="search-form" name="car-rental" #form="ngForm">
    <div class="search-form__engine search-form__engine--two-rows">
      <div class="search-form__row">
        <div class="search-form__select search-form__select--flex search-form__element">
          <div class="form-group-custom">
            <label for="inputDestinationHotel" class="input-group-zeus__label">Destinazione</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="inputDestinationHotel-select">
              <ng-select [items]="hotels$ | async" [typeahead]="hotelQuery$"
                         placeholder="Nome Hotel o Destinazione"
                         name="location"
                         required
                         [loading]="isLoading" [(ngModel)]="selectedHotel"
                         [minTermLength]="3" typeToSearchText="Scrivi 3 o piu' caratteri"
                         id = "inputDestinationHotel"
                         class="form-control-custom">
                <ng-template ng-label-tmp let-item="item">
                  <span>{{getHotelItemName(item) | stripTags}}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <span [innerHTML]="getHotelItemName(item)"></span>
                </ng-template>
              </ng-select>
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon1"><i class="icon-pin"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="search-form__select search-form__element">
          <div class="form-group-custom">
            <label for="checkinHotel-input" class="input-group-zeus__label">Check-in</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="checkinHotel-input">
              <input readonly [(ngModel)]="selectedCheckinDate"
                     type="text"
                     placeholder="Check-In"
                     name="checkin"
                     required
                     ngbDatepicker #dpA="ngbDatepicker" (click)="dpA.toggle()"
                     class="form-control-custom">
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon2"><i class="icon-pin"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="search-form__select search-form__element">
          <div class="form-group-custom">
            <label for="checkoutHotel-input" class="input-group-zeus__label">Check-Out</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="checkoutHotel-input">
              <input readonly [(ngModel)]="selectedCheckoutDate"
                     type="text"
                     placeholder="Check-Out"
                     name="checkout"
                     required
                     ngbDatepicker #dpR="ngbDatepicker" (click)="dpR.toggle()"
                     class="form-control-custom">
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon3"><i class="icon-pin"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="search-form__row">
        <div class="search-form__select search-form__element">
          <div class="form-group-custom">
            <label for="inputRoomsHotel" class="input-group-zeus__label">Camere</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="inputRoomsHotel-select">
              <ng-select [items]="rooms"
                         [(ngModel)]="selectedRooms"
                         name="rooms"
                         required
                         id = "inputRoomsHotel"
                         class="form-control-custom">
                <ng-template ng-label-tmp let-item="item">
                  <span>{{item}} Camera</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <span>{{item}} Camera</span>
                </ng-template>
              </ng-select>
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon4"><i class="icon-pin"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="search-form__select search-form__select--flex search-form__element">
          <div class="form-group-custom">
            <label for="passengerHotel-input" class="input-group-zeus__label">Adulti</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="passengerHotel-input">
              <input readonly (click)="openPassengersModal(passengers)"
                     [placeholder]="getPassengerString(passengers)"
                     type="text"
                     name="passenger"
                     required
                     class="form-control-custom">
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon5"><i class="icon-pin"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="search-form__select search-form__select--flex search-form__element" *ngIf="selectedRooms === 2">
          <div class="form-group-custom">
            <label for="passenger2Hotel-input" class="input-group-zeus__label">Adulti Camera 2</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="passenger2Hotel-input">
              <input readonly (click)="openPassengersModal(passengers2)"
                     [placeholder]="getPassengerString(passengers2)"
                     type="text"
                     name="passenger2"
                     class="form-control-custom">
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon6"><i class="icon-pin"></i></span>
              </div>
            </div>
          </div>
        </div>
        <button [disabled]="form.invalid" (click)="doSearch()"
                class="search-form__cta search-form__element btn btn--sm btn--brand-color-03 btn__uppercase mt-3">Cerca <i class="icon-search"></i></button>
      </div>
    </div>
  </form>
</div>

<!--
<ng-select [items]="hotels$ | async" [typeahead]="hotelQuery$"
           placeholder="Nome Hotel o Destinazione"
           [loading]="isLoading" [(ngModel)]="selectedHotel"
           [minTermLength]="3" typeToSearchText="Scrivi 3 o piu' caratteri">
  <ng-template ng-label-tmp let-item="item">
    <span>{{getHotelItemName(item) | stripTags}}</span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
    <span [innerHTML]="getHotelItemName(item)"></span>
  </ng-template>
</ng-select>

<input readonly [(ngModel)]="selectedCheckinDate" type="text" placeholder="Check-In" ngbDatepicker #dpA="ngbDatepicker" (click)="dpA.toggle()">

<input readonly [(ngModel)]="selectedCheckoutDate" type="text" placeholder="Check-Out" ngbDatepicker #dpR="ngbDatepicker" (click)="dpR.toggle()">

<ng-select [items]="rooms"
           [(ngModel)]="selectedRooms">
  <ng-template ng-label-tmp let-item="item">
    <span>{{item}} Camera</span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
    <span>{{item}} Camera</span>
  </ng-template>
</ng-select>

<input readonly (click)="openPassengersModal(passengers)" [placeholder]="getPassengerString(passengers)">

<input *ngIf="selectedRooms === 2" readonly (click)="openPassengersModal(passengers2)" [placeholder]="getPassengerString(passengers2)">

<button [disabled]="!canSearch()" (click)="doSearch()" class="btn btn-info">Cerca</button>
-->
